module.exports = __webpack_public_path__ + "img/imgStep05.6636a05d.png";